import { useQuery } from "@tanstack/react-query";
import { coreDataGetDogBreedsOptions } from "@/api_client/@tanstack/react-query.gen";
import { useLanguageFromUrl } from "../useLanguageFromUrl";

export const useDogBreeds = () => {
  const language = useLanguageFromUrl();
  return useQuery({
    ...coreDataGetDogBreedsOptions({ query: { language } }),
    staleTime: (options) => {
      const result =
        Object.keys(options.state.data ?? {}).length > 0 ? Infinity : 0;
      return result;
    },
  });
};

export const useDogBreed = (dogBreedKey: string | null | undefined) => {
  const { data: dogBreeds, isLoading: isLoadingDogBreeds } = useDogBreeds();
  if (isLoadingDogBreeds || !dogBreeds || !dogBreedKey) {
    return undefined;
  }
  const dogBreedItem = dogBreeds?.items?.find((c) => c.key === dogBreedKey);
  const dogBreed = dogBreedItem?.value ?? dogBreedKey;
  return dogBreed;
};
